<div class="d-flex justify-content-end paginator">

    @if (isControlPageSize) {
    <div [formGroup]="filterPaginator">
        <span class="color-text">
            {{ 'paginator.resultados' | translate}}
        </span>
        <select id="pageSize" (change)="changeSize()" formControlName="pageSize">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
        </select>
    </div>
    }
    <button class="btn color-text" name="firtsPage" aria-label="firtsPage"
        (click)="changePage(1); $event.preventDefault()" [disabled]="isStart">
        <!--<img src="assets/images/paginator/firstpage.svg" alt="Primera página">-->
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
            class="bi bi-chevron-bar-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
                d="M11.854 3.646a.5.5 0 0 1 0 .708L8.207 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0M4.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5" />
        </svg>
    </button>

    <button class="btn color-text" name="backPage" aria-label="backPage" (click)="goToPreviousPage()"
        [disabled]="isStart">
        <!--<img src="assets/images/paginator/pageBefore.svg" alt="before">-->
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
            class="bi bi-chevron-compact-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
                d="M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223" />
        </svg>
    </button>

    <span class="color-text">
        Página {{ currentPage }} de {{ totalPages == 0 ? 1 : totalPages }}
    </span>

    <button class="btn color-text" name="nextPage" aria-label="nextPage" (click)="goToNextPage()" [disabled]="isEnd">
        <!--<img src="assets/images/paginator/pageAfter.svg" alt="after">-->
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
            class="bi bi-chevron-compact-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
                d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671" />
        </svg>
    </button>

    <button class="btn color-text" name="lastPage" aria-label="lastPage"
        (click)="changePage(this.totalPages); $event.preventDefault()" [disabled]="isEnd">
        <!--<img src="assets/images/paginator/lastPage.svg" alt="last">-->
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
            class="bi bi-chevron-bar-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
                d="M4.146 3.646a.5.5 0 0 0 0 .708L7.793 8l-3.647 3.646a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708 0M11.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5" />
        </svg>
    </button>

</div>